import React from "react";
import "./Vision_Mission_Value.css";
import { VisionMissions } from "../../../utils/apis/aboutus/Aboutus.js";
import { useEffect, useState } from "react";
import { IDS } from "../../../utils/common";

const Vision_Mission_Value = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [visionmission, setVisionMission] = useState([]);

  const getVisionMission = async () => {
    const res = await VisionMissions();

    if (res?.success) {
      setVisionMission(res?.data || []);
    }
  };

  useEffect(() => {
    getVisionMission();
  }, []);

  const vision = visionmission.find((item) =>
    item.name?.toLowerCase().includes("vision"),
  );

  const mission = visionmission.find((item) =>
    item.name?.toLowerCase().includes("mission"),
  );

  const value = visionmission.find((item) =>
    item.name?.toLowerCase().includes("value"),
  );

  return (
    <section className="vision_mission_section">
      <div className="custom_container">
        <div className="columns_wrapper">
          {/* Vision */}
          <div className="column ">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="content_image">
                  <img src={IDS?.IMG_URL + vision?.image} alt="Vision" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="content_block ">
                  <h3>{vision?.name}</h3>
                  <p>{htmlToReactParser.parse(vision?.description || "")}</p>

                  <div className="hr_holder"></div>
                  <h3>{mission?.name}</h3>
                  <p>{htmlToReactParser.parse(mission?.description || "")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision_Mission_Value;
